import * as React from 'react';
import Modal from 'react-bootstrap/Modal';

interface ReopenJobProps {
    reopenJob: ReopenJob;
    showModal: boolean;
    hideModal(): void;
    updateData(updatedJob: ReopenJob): void;
    save(): void;
}

interface ReopenJobModal {
    errors: any;
    loading: boolean;
}

interface ReopenJob {
    rowIndex: number;
    id: number;
    itemId: number;
    item: string;
    actualQuantity: number;
    quantity: number;
    rescheduleQuantity: number;
    schedulePickup: boolean;
    offhireDate: string;
    scheduleDate: string;
    isKwikstage: boolean;
    kwikstageItems: ReopenJobKwikstageItem[];
}

interface ReopenJobKwikstageItem {
    id: number;
    jobQuoteItemCalculationId: number;
    starterBayId: number;
    starterBay: string;
    liftId: number;
    lift: string;
    baysTotal: number;
    bays: number;
    newBays: number;
    rescheduleBays: number;
}

export default class ReopenJobData extends React.Component<ReopenJobProps, ReopenJobModal> {
    constructor(props: ReopenJobProps) {
        super(props);
        this.state = {
            errors: {},
            loading: false
        }
    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        var reopenJob = this.props.reopenJob;
        let newReopenJob: any = {};
        newReopenJob = reopenJob;
        newReopenJob[e.target.name] = e.target.value;

        let rescheduleQuantity = 0;
        if (e.target.name === "quantity") {
            //need to calculate reschedule quantity
            rescheduleQuantity = reopenJob.actualQuantity - e.target.value;
            newReopenJob["rescheduleQuantity"] = rescheduleQuantity;
        }

        this.setState({ errors: errors });
        this.props.updateData(reopenJob);
    }

    handleCheckboxChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        var reopenJob = this.props.reopenJob;
        let newReopenJob: any = {};
        newReopenJob = reopenJob;
        newReopenJob[e.target.name] = e.target.checked;

        this.setState({ errors: errors });
        this.props.updateData(reopenJob);
    }

    hideReopenJobModal = () => {
        this.setState({ errors: {} });
        this.props.hideModal();
    }

    onCellChange = (e: any, index: number) => {
        var errors = this.state.errors;
        delete errors["kwikstageItems"];

        var reopenJob = this.props.reopenJob;
        var items = reopenJob.kwikstageItems;
        var item = items[index];

        var newBays = e.target.value * 1;
        item.newBays = newBays;
        item.rescheduleBays = item.bays - newBays;

        this.props.updateData(reopenJob);
    }

    validate = () => {
        let fields = this.props.reopenJob;
        let errors: any = {};
        let formIsValid = true;

        if (fields.isKwikstage) {
            var newTotal = 0;
            for (var i = 0; i < fields.kwikstageItems.length; i++) {
                newTotal += fields.kwikstageItems[i].newBays * 1;
            }
            if (newTotal === 0) {
                formIsValid = false;
                errors["kwikstageItems"] = "At least 1 KS Item Bays > 0 is required";
            }
        } else {
            if (fields.quantity >= fields.actualQuantity) {
                formIsValid = false;
                errors["quantity"] = "Quantity < Actual Quantity is required";
            }
        }

        if (fields.schedulePickup) {
            //dates only mandatory when we are rescheduling the remaining quantity
            if (!fields.offhireDate) {
                formIsValid = false;
                errors["offhireDate"] = "Offhire Date is required";
            }

            if (!fields.scheduleDate) {
                formIsValid = false;
                errors["scheduleDate"] = "Schedule Date is required";
            }
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    save = (e: any) => {
        e.preventDefault();

        if (this.validate()) {
            this.props.save();
        }
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return (<div>
            {contents}
        </div>);
    }

    renderDetails = () => {
        let reopenJob = this.props.reopenJob;

        return (
            <div className="static-modal">
                <Modal show={this.props.showModal} onHide={this.hideReopenJobModal}>
                    <Modal.Header className="modal__header--colour">
                        <Modal.Title>Re-open {reopenJob.item}</Modal.Title>
                        <button type="button" className="close" onClick={this.hideReopenJobModal}>&times;</button>
                    </Modal.Header>
                    <Modal.Body>
                        <div className={this.props.reopenJob.isKwikstage ? "hidden" : ""}>
                            <span className="marginLeft10"><u>Original Item</u></span>
                            <label className="input-group input-group--nowrap" htmlFor="actualQuantity">
                                <span className="label">Actual Quantity</span>
                                <input className="input textalignright" type="number" id="actualQuantity" name="actualQuantity" value={reopenJob.actualQuantity} disabled></input>
                            </label>
                        
                            <label className="input-group input-group--nowrap" htmlFor="quantity">
                                <span className="label">Quantity</span>
                                <input className="input textalignright" type="number" id="quantity" name="quantity" value={reopenJob.quantity} onChange={(e) => this.handleChange(e)}></input>
                            </label>
                            <span className="label errors">{this.state.errors["quantity"]}</span>
                        
                            <span className="marginLeft10"><u>Reschedule Item</u></span>
                            <label className="input-group input-group--nowrap" htmlFor="rescheduleQuantity">
                                <span className="label">Reschedule Quantity</span>
                                <input className="input textalignright" type="number" id="rescheduleQuantity" name="rescheduleQuantity" value={reopenJob.rescheduleQuantity} disabled></input>
                            </label>
                        </div>
                        <div className={this.props.reopenJob.isKwikstage ? "" : "hidden"}>
                            <span>Enter Actual Bays: number of Bays that have been picked up. Reschedule Bays will calculate the remaining for scheduling</span>
                            <div className='overflowAuto'>
                                <table className='table table__small tableColours'>
                                    <thead>
                                        <tr>
                                            <th className="hidden">Id</th>
                                            <th></th>
                                            <th>Starter Bay</th>
                                            <th>Lift</th>
                                            <th>Original Bays</th>
                                            <th>Actual Bays</th>
                                            <th>Reschedule Bays</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {reopenJob.kwikstageItems.map((item, index) =>
                                            <tr key={index}>
                                                <td className="hidden">{item.jobQuoteItemCalculationId}</td>
                                                <td className="table__text--align">{index + 1}</td>
                                                <td className="table__text--align">{item.starterBay}</td>
                                                <td className="table__text--align">{item.lift}</td>
                                                <td className="table__text--align">{item.bays}</td>
                                                <td className="table__text--align">
                                                    <input type='number' id="newBays" name="newBays" className="input schedulenew__text-sm" value={item.newBays} onChange={(e) => this.onCellChange(e, index)} />
                                                </td>
                                                <td className="table__text--align">{item.rescheduleBays}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <span className="label errors">{this.state.errors["kwikstageItems"]}</span>
                            </div>
                        </div>
                        <label className="input-group" htmlFor="copyQuote">
                                <span className="label">Schedule Pickup</span>
                                <input className="input checkbox__Size" type="checkbox" id="schedulePickup" name="schedulePickup" checked={reopenJob.schedulePickup} onChange={(e) => this.handleCheckboxChange(e)}></input>
                            </label>
                        <div className={this.props.reopenJob.schedulePickup ? "" : "hidden"}>
                            <label className="input-group" htmlFor="offhireDate">
                                <span className="label">Offhire Date</span>
                                <input type='date' id="offhireDate" name="offhireDate" className='input' value={this.props.reopenJob.offhireDate} onChange={(e) => this.handleChange(e)}></input>
                            </label>
                            <span className="label errors">{this.state.errors["offhireDate"]}</span>
                            <label className="input-group" htmlFor="scheduleDate">
                                <span className="label">Schedule Date</span>
                                <input type='date' id="scheduleDate" name="scheduleDate" className='input' value={this.props.reopenJob.scheduleDate} onChange={(e) => this.handleChange(e)}></input>
                            </label>
                            <span className="label errors">{this.state.errors["scheduleDate"]}</span>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <button className="popup-button--yes" onClick={this.save}>Save</button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}